import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Boucherpopup from '../../Components/Popupform/Boucherpopup';
import Popupform from '../../Components/Popupform/Popupform';
import config from '../../config/config';
import { Link } from 'react-router-dom';
import axios from 'axios';


const Page = () => {
    const [showPopup, setShowPopup] = useState(false);

    const handleOpenPopup = (e) => {
        e.preventDefault(); // Prevent navigation
        setShowPopup(true);
        document.body.style.overflow = "hidden"; // Disable background scrolling
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        document.body.style.overflow = "auto"; // Enable background scrolling
    };


    const [showBoucherPopup, setShowBoucherPopup] = useState(false);

    const handleOpenBoucherPopup = () => setShowBoucherPopup(true);
    const handleCloseBoucherPopup = () => setShowBoucherPopup(false);


    const pageID = useParams();

    const [study, setStudy] = useState([]);

    useEffect(() => {
        const fetchStudyabroadData = async () => {
            try {
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/admin/get_studyaboradbyId/${pageID.id}`
                );
                const fetchedData = response.data.getAllStudyAboradById || [];
                setStudy(fetchedData);
                console.log("fetchedData", fetchedData); // Log for debugging
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };

        fetchStudyabroadData();
    }, []);

    return (
        <>
            {/* Premium Hero Banner */}
            <div className="relative w-full h-[400px] flex items-center justify-center bg-gray-900 overflow-hidden">
                {/* Background Image & Overlay */}
                <div className="absolute inset-0 z-0">
                    <img
                        src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=2070&auto=format&fit=crop"
                        alt="Study Abroad"
                        className="w-full h-full object-cover opacity-40"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent"></div>
                </div>

                <div className="container relative z-10 text-center px-4">
                    <span className="inline-block py-1 px-3 rounded-full bg-blue-500/20 border border-blue-400/30 text-blue-300 text-xs font-bold uppercase tracking-wider mb-4 backdrop-blur-sm">
                        Global Education
                    </span>
                    <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight drop-shadow-lg">
                        {study.bannnerHeading}
                    </h1>
                    <div className="flex flex-col md:flex-row items-center justify-center gap-2 text-gray-300 text-sm md:text-base max-w-2xl mx-auto mb-8">
                        <p>{study.bannnerSubHeading1}</p>
                        <span className="hidden md:block text-gray-500">•</span>
                        <p>{study.bannnerSubHeading2}</p>
                    </div>

                    <div className="flex flex-wrap justify-center gap-4">
                        <button
                            className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-orange-500/30 transition-all transform hover:-translate-y-1"
                            onClick={handleOpenPopup}
                        >
                            Apply Now
                        </button>
                        <button
                            className="bg-white/10 hover:bg-white/20 text-white border border-white/30 font-bold py-3 px-8 rounded-full backdrop-blur-md transition-all flex items-center gap-2"
                            onClick={handleOpenBoucherPopup}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                            Download Brochure
                        </button>
                    </div>
                </div>
            </div>


            {/* Popup Modal */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <button className="close-btn" onClick={handleClosePopup}>
                            &times;
                        </button>
                        <Popupform />
                    </div>
                </div>
            )}

            {/* Boucher Popup */}
            {showBoucherPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <button className="close-btn" onClick={handleCloseBoucherPopup}>
                            &times;
                        </button>
                        <Boucherpopup />
                    </div>
                </div>
            )}



            {/* study abroad table  */}

            <div className="container mt-5">
                {/* heading */}
                <h1 className='exploretitle fs-3'>
                    {study.tableHeading}
                </h1>
                <p className='explore_para text-left'>{study.tableSubHeading}</p>
                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center align-middle">
                                <thead>
                                    <tr style={{ backgroundColor: "#dfe8e7" }}>
                                        <th>Universities</th>
                                        <th>Application Fees</th>
                                        <th>Apply via Us</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {study?.tablelist?.map((uni, index) => (
                                        <tr key={index}>
                                            <td className="fw-bold fs-6">
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={`${config.API_BASE_URL}/uploads/${uni.image}`}
                                                        alt="university logo"
                                                        className="me-2"
                                                        style={{ width: '30px', height: '30px', objectFit: 'contain' }}
                                                    />
                                                    <span>{uni.collageName}</span>
                                                </div>
                                            </td>
                                            <td>{uni.fees}</td>
                                            <td>{uni.dicountFee}</td>
                                            <td>
                                                <button className="mybtn" onClick={handleOpenPopup}>Apply Now</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>







            {/* cards section  */}

            {/* Explore Courses For Canada */}

            {/* programe cards container end  */}
            <div className="container">

                {/* heading */}
                <h1 className='exploretitle fs-3 mt-5'>
                    Explore Courses For {study.pageName}
                </h1>
                <div className="row mt-3 pt-3 progcontainer">
                    {study?.cardlist?.map((item) => (
                        <div key={item._id} className="col-lg-3 col-md-4 col-sm-6">
                            <div className="text-center h-75 shadow m-1 border-0 cardcls">
                                <img src={`${config.API_BASE_URL}/uploads/${item.image}`}

                                    className="text-center m-auto img-fluid"
                                    alt={item.image || "No Name"}
                                    style={{ width: "30%" }}
                                />
                                <div className="card-body text-center">
                                    <h5 className="card_title">
                                        {item.text || "No Name"}
                                    </h5>
                                    <Link to="/" className='nav-link'>Colleges</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
            {/* Program / cards container end  */}


        </>
    )
}

export default Page
